import React from "react";
import ArrowBack from "@mui/icons-material/ArrowBack";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import Tabs from "@mui/material/Tabs";
import TabPanel from "@mui/lab/TabPanel";
import { Box, Button } from "@mui/material";
import { boxStyle } from "../../style/style";
import { useState } from "react";
import Devices from "../../components/Devices";
import CustomerHubs from "../CustomerComponent/CustomerHubs";
import CustomerStat from "../CustomerComponent/CustomerStat";
import DeviceDetail from "../DeviceDetail";
import Profile from "../Profile";

export default function OrgDetail(props) {
  const [value, setvalue] = useState("1");
  const [devicedetail, setdevicedetail] = useState(false);
  const handleChange = (val) => {
    //props.search.setsearch("");
    setvalue(val);
    props.setclicked(false);
    props.setsearch("");
  };
  return (
    <div>
      {!devicedetail && (
        <TabContext value={value}>
          <Box sx={boxStyle}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                //onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label="Devices"
                  value={"1"}
                  onClick={() => handleChange("1")}
                />
                <Tab
                  label="Hubs"
                  value={"2"}
                  onClick={() => handleChange("2")}
                />
                <Tab
                  label="Profile"
                  value={"3"}
                  onClick={() => handleChange("3")}
                />
                <Tab
                  label="Dashboard"
                  value={"4"}
                  onClick={() => handleChange("4")}
                />
              </Tabs>
            </Box>
            <Button
              sx={{ float: "left" }}
              onClick={() => {
                props.setdetail(false);
              }}
              startIcon={<ArrowBack />}
            ></Button>
          </Box>
          <TabPanel value={"1"}>
            <Devices
              id={props.id}
              search={props.clicked ? props.search : ""}
              value={{ value: value, setvalue: setvalue }}
              devicedetail={{
                devicedetail: devicedetail,
                setdevicedetail: setdevicedetail,
              }}
            />
          </TabPanel>
          <TabPanel value={"2"}>
            <CustomerHubs
              id={props.id}
              search={props.clicked ? props.search : ""}
              devicedetail={{
                devicedetail: devicedetail,
                setdevicedetail: setdevicedetail,
              }}
            />
          </TabPanel>
          <TabPanel value={"3"}>
            <Profile id={props.id} />
          </TabPanel>
          <TabPanel value={"4"}>
            <CustomerStat id={props.id} />
          </TabPanel>
        </TabContext>
      )}
      {devicedetail && (
        <DeviceDetail
          devicedetail={{
            devicedetail: devicedetail,
            setdevicedetail: setdevicedetail,
          }}
        />
      )}
    </div>
  );
}
